module.exports = __webpack_public_path__ + "img/gap.dd60e9d0.gif";